import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Type } from '@nerdwallet/currency';

import ImageHero from '../image-hero/image-hero';
import CompanyHeader from './company-header/company-header';
import CompanyMatrix from './company-matrix/company-matrix';
import CompanyStroke from '../company-stroke/company-stroke';

import ImageHeroContent from '../../lib/company-content-src/image-hero-content';
import CompanyValuesContent from '../../lib/company-content-src/company-values-content';
import CompanyTypeboxContent from '../../lib/company-content-src/company-typebox-content';

const CompanyPage = () => (
  <div>
    <ImageHero
      preheader={ImageHeroContent.company.preheader}
      title={ImageHeroContent.company.title}
      body={ImageHeroContent.company.body}
      bodyMobile={ImageHeroContent.company.bodyMobile}
      buttonText={ImageHeroContent.company.buttonText}
      buttonLink={ImageHeroContent.company.buttonLink}
      backgroundClassName={ImageHeroContent.company.backgroundClassName}
    />
    <CompanyHeader headerText="Our Mission" />
    <Type
      gotham
      className={classNames([
        classes('margin-horizontal-3'),
        classes('margin-vertical-5'),
        classes('max-width-prose-wide--wide'),
        classes('margin-horizontal-auto--wide'),
        classes('text-small'),
        classes('text-default--wide'),
      ])}
    >
      {CompanyTypeboxContent.mission.body}
    </Type>
    <ImageHero
      backgroundClassName={ImageHeroContent.mission.backgroundClassName}
    />
    <CompanyHeader headerText="Our Headquarters" />
    <Type
      gotham
      className={classNames([
        'hq',
        classes('margin-horizontal-3'),
        classes('margin-vertical-5'),
        classes('max-width-prose-wide--wide'),
        classes('margin-horizontal-auto--wide'),
        classes('text-small'),
        classes('text-default--wide'),
      ])}
    >
      {CompanyTypeboxContent.hq.body}
    </Type>
    <ImageHero backgroundClassName={ImageHeroContent.hq.backgroundClassName} />
    <CompanyHeader headerText="Our Values" />
    <Type
      gotham
      className={classNames([
        classes('margin-horizontal-3'),
        classes('margin-vertical-5'),
        classes('max-width-prose-wide--wide'),
        classes('margin-horizontal-auto--wide'),
        classes('text-small'),
        classes('text-default--wide'),
      ])}
    >
      {CompanyTypeboxContent.values.body}
    </Type>
    <div className={classNames([classes('margin-vertical-5')])}>
      <ImageHero
        backgroundClassName={ImageHeroContent.values.backgroundClassName}
      />
    </div>
    <CompanyMatrix {...CompanyValuesContent} />
    <ImageHero
      backgroundClassName={ImageHeroContent.payforward.backgroundClassName}
    />
    <CompanyHeader headerText="Pay It Forward" />
    <Type
      gotham
      className={classNames([
        classes('margin-horizontal-3'),
        classes('margin-vertical-5'),
        classes('max-width-prose-wide--wide'),
        classes('margin-horizontal-auto--wide'),
        classes('text-small'),
        classes('text-default--wide'),
      ])}
    >
      {CompanyTypeboxContent.payforward.body}
    </Type>
    <CompanyStroke />
    <div
      className={classNames([
        classes('width-auto'),
        classes('text-align-center'),
        classes('margin-vertical-5'),
        classes('margin-horizontal-3'),
      ])}
    >
      <Type
        gotham
        size="3"
        className={classNames([
          classes('display-none--wide'),
          classes('max-width-prose'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        Be a part of life at NerdWallet.
        <br />
        Join our team.
      </Type>
      <Type
        gotham
        size="3"
        className={classNames([
          classes('display-none'),
          classes('display-block--wide'),
          classes('max-width-prose-wide'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        Be a part of life at NerdWallet. Join our team.
      </Type>
      <Button primary href="/careers">
        Apply now
      </Button>
    </div>
  </div>
);

CompanyPage.displayName = 'Company Page';

export default CompanyPage;
